import React from 'react';
import Typography from '@material-ui/core/Typography';

const NotFound = () => (
  <div>
    <Typography variant="h3">
      404 Not Found
    </Typography>
  </div>
);

export default NotFound;
